<template>
    <div
        v-if="testimonials.length || agentid !== -1"
        class="md-testimonial reviews-online"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <!-- TODO:  The reason for changing the title  -->
            <div v-if="title" class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div class="reviews-container">
                <agent-info
                    v-if="isValidAgent && agent"
                    :agent="agent"
                    class="column-left"
                ></agent-info>
                <comments
                    @updateComments="updateComments"
                    :testimonials="testimonials"
                    :reviewAddTitle="reviewAddTitle"
                    :testimonialTitle="testimonialTitle"
                    class="comments"
                ></comments>
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../index';
import comments from './comments.vue';
import agentInfo from './agent-info.vue';

export default {
    mixins: [common],
    data: function() {
        return {
            testimonialTitle: '',
            reviewAddTitle: ''
        };
    },
    components: {
        agentInfo,
        comments
    },
    methods: {
        updateComments(id = undefined) {
            //  Adding a comment triggers an update
            this.getTestimonials(id);
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
.md-testimonial.reviews-online {
    .reviews-container {
        display: flex;
        align-items: flex-start;
        .column-left {
            flex: none;
            margin-right: 40px;
            padding-bottom: 20px;
        }
        .comments {
            flex: 1;
            .recommend-box {
                .md-testimionial.comment-list {
                    padding-top: 32px;
                }
            }
        }
    }
}

@import './responsive.scss';
</style>
